import './styles/main.scss';
import '@popperjs/core';
import 'bootstrap';
import 'slick-carousel';
import 'jquery-match-height';
import 'sticky-sidebar';

// import 'gsap';
// import 'gsap/gsap-core';
import './scripts/index';

// import polyfill]
// import 'custom-event-polyfill';

// import AOS from 'aos';

// import React from 'react'
// import ReactDOM from 'react-dom';

window.jQuery = $;
window.$ = $;

window.$ = window.jQuery = require( 'jquery' );

// window.addEventListener(
// 	'load', ( ) => {
// 		AOS.init( {
// 			once: true,
// 			duration: 1000,
// 			disable: 'mobile',
// 		}
// 		);
// 	}
// );

